class NewsDetailsModel {
	id;
	title;
	subtitle;
	category;
	date;
	image;
	description;
	slug;
	video;


	constructor({
		_id = '', title = '', subtitle = '', category = '', date = '',
		image = '', description = '', slug = '', video = '',
	}) {
		this.id = _id;
		this.title = title;
		this.subtitle = subtitle;
		this.category = category;
		this.date = date;
		this.image = image;
		this.description = description;
		this.slug = slug;
		this.video = video;
	}
}

export default NewsDetailsModel;
